import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    host_box: {
        overflow: 'hidden',
    },
    host_text: {
        width: 'calc(70vw - 48px)',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    partner_logo: {
        display: 'flex',
        backgroundPosition: 'center',
        backgroundImage: props => `url(${props.partnerImg})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        height: '80px',
        width: 'auto',
    },
}));